import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMail = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_9562_371)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M12.6667 0.667969H3.33333C2.4496 0.669027 1.60237 1.02056 0.97748 1.64545C0.352588 2.27034 0.00105857 3.11757 0 4.0013L0 12.0013C0.00105857 12.885 0.352588 13.7323 0.97748 14.3572C1.60237 14.982 2.4496 15.3336 3.33333 15.3346H12.6667C13.5504 15.3336 14.3976 14.982 15.0225 14.3572C15.6474 13.7323 15.9989 12.885 16 12.0013V4.0013C15.9989 3.11757 15.6474 2.27034 15.0225 1.64545C14.3976 1.02056 13.5504 0.669027 12.6667 0.667969ZM3.33333 2.0013H12.6667C13.0659 2.00209 13.4557 2.12231 13.786 2.3465C14.1163 2.5707 14.3719 2.8886 14.52 3.2593L9.41467 8.3653C9.03895 8.73951 8.53028 8.94961 8 8.94961C7.46972 8.94961 6.96105 8.73951 6.58533 8.3653L1.48 3.2593C1.6281 2.8886 1.88374 2.5707 2.21403 2.3465C2.54432 2.12231 2.93414 2.00209 3.33333 2.0013ZM12.6667 14.0013H3.33333C2.8029 14.0013 2.29419 13.7906 1.91912 13.4155C1.54405 13.0404 1.33333 12.5317 1.33333 12.0013V5.0013L5.64267 9.30797C6.26842 9.93214 7.11617 10.2827 8 10.2827C8.88383 10.2827 9.73158 9.93214 10.3573 9.30797L14.6667 5.0013V12.0013C14.6667 12.5317 14.456 13.0404 14.0809 13.4155C13.7058 13.7906 13.1971 14.0013 12.6667 14.0013Z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_9562_371",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
export default SvgMail;
